export default "__VITE_ASSET__557c4bb3__"